// import React from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "../components/layout/Layout";
import LoginNew from "../features/login/Login";
import User from "../features/user/User";
import CreateUser from "../features/user/CreateUser";
import UserType from "../features/userType/UserType";
import CreateUserType from "../features/userType/CreateUserType";
import Rights from "../features/rights/Rights";
import Menu from "../features/menu/Menu";
import PrivateRoute from "./PrivateRoute";
// import Dashboard from "../features/dashboard/Dashboard";
// import LoginNew from "../features/login/LoginNew";
import PendingDocumentTourBooking from "../features/dashboard/lists/PendingDocumentTourBooking";
import TotalTourBooking from "../features/dashboard/lists/TotalTourBooking";
// import TotalPayment from "../features/dashboard/lists/TotalPayment";
import TotalPendingPayment from "../features/dashboard/lists/TotalPendingPayment";
import TotalDepartureInNextFifteenDay from "../features/dashboard/lists/TotalDepartureInNextFifteenDay";

import Banner from "../features/banner/Banner";
import CreateBanner from "../features/banner/CreateBanner";
import CMS from "../features/cms/CMS";
import SeoTag from "../features/seotag/SeoTag";
import CreateSeoTag from "../features/seotag/CreateSeoTag";
import Testimonial from "../features/testimonial/Testimonial";
import CreateCMS from "../features/cms/CreateCMS";
import Blog from "../features/blog/Blog";
import CreateBlog from "../features/blog/CreateBlog";
import Service from "../features/services/Services";
import CreateService from "../features/services/CreateServices";
import FAQ from "../features/faq/FAQ";
import UsefulLinks from "../features/usefullinks/UsefulLinks";
import CreateUsefulLinks from "../features/usefullinks/CreateUsefulLinks";
import Quotation from "../features/quotation/Quotation";
import Contact from "../features/contact/Contact";
import Setting from "../features/setting/Setting";
import Destination from "../features/destination/Destination";
import CreateDestination from "../features/destination/CreateDestination";
import News from "../features/news/News";
import CreateNews from "../features/news/CreateNews";
import Course from "../features/course/Course";
import CreateCourse from "../features/course/CreateCourse";
import Branch from "../features/branch/Branch";
import Inquiry from "../features/inquiry/Inquiry";
import TeamMember from "../features/teammember/TeamMember";
import Client from "../features/client/Client";
import CoreService from "../features/coreservices/CoreServices";
import CreateCoreService from "../features/coreservices/CreateCoreServices";
import Howitworks from "../features/howitworks/Howitworks";
import Gallery from "../features/gallery/Gallery";
import CreateGallery from "../features/gallery/CreateGallery";

const MainRouter = () => {
  return (
    <Routes>
      {/* <Route path="login" element={<LogIn />} /> */}
      {/* <Route path="newlogin" element={<NewLogin />} /> */}
      <Route path="login" element={<LoginNew />} />

      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        {/* <Route index={true} element={<Dashboard />} /> */}
        <Route index={true} element={<Banner />} />
        <Route path="menu" element={<Menu />} />
        <Route path="rights" element={<Rights />} />
        <Route path="user" element={<User />} />
        <Route path="user/create" element={<CreateUser />} />
        <Route path="user/edit" element={<CreateUser />} />
        <Route path="usertype" element={<UserType />} />
        <Route path="usertype/create" element={<CreateUserType />} />
        <Route path="usertype/edit" element={<CreateUserType />} />
        <Route path="cms" element={<CMS />} />
        <Route path="cms/edit" element={<CreateCMS />} />
        <Route path="cms/create" element={<CreateCMS />} />
        <Route path="banner" element={<Banner />} />
        <Route path="banner/create" element={<CreateBanner />} />
        <Route path="banner/edit" element={<CreateBanner />} />
        <Route path="seotag" element={<SeoTag />} />
        <Route path="seotag/create" element={<CreateSeoTag />} />
        <Route path="seotag/edit" element={<CreateSeoTag />} />
        <Route path="testimonial" element={<Testimonial />} />
        <Route path="howitworks" element={<Howitworks />} />
        <Route path="blog" element={<Blog />} />
        <Route path="blog/create" element={<CreateBlog />} />
        <Route path="blog/edit" element={<CreateBlog />} />
        <Route path="service" element={<Service />} />
        <Route path="service/create" element={<CreateService />} />
        <Route path="service/edit" element={<CreateService />} />

        <Route path="faq" element={<FAQ />} />
        <Route path="branch" element={<Branch />} />
        {/* <Route path="faq/create" element={<CreateFAQ />} />
        <Route path="faq/edit" element={<CreateFAQ />} /> */}

        <Route path="destination" element={<Destination />} />
        <Route path="destination/create" element={<CreateDestination />} />
        <Route path="destination/edit" element={<CreateDestination />} />

        <Route path="news" element={<News />} />
        <Route path="news/create" element={<CreateNews />} />
        <Route path="news/edit" element={<CreateNews />} />

        <Route path="course" element={<Course />} />
        <Route path="course/create" element={<CreateCourse />} />
        <Route path="course/edit" element={<CreateCourse />} />

        <Route path="usefullinks" element={<UsefulLinks />} />
        <Route path="usefullinks/create" element={<CreateUsefulLinks />} />
        <Route path="usefullinks/edit" element={<CreateUsefulLinks />} />
        <Route path="quotation" element={<Quotation />} />
        <Route path="inquiries" element={<Contact />} />
        <Route path="setting" element={<Setting />} />
        <Route path="inquiry" element={<Inquiry />} />
        <Route path="teammember" element={<TeamMember />} />
        <Route path="client" element={<Client />} />
        <Route path="gallery" element={<Gallery />} />
        <Route path="gallery/create" element={<CreateGallery />} />
        <Route path="gallery/edit" element={<CreateGallery />} />

        <Route path="coreservice" element={<CoreService />} />
        <Route path="coreservice/create" element={<CreateCoreService />} />
        <Route path="coreservice/edit" element={<CreateCoreService />} />
        <Route
          path="dashboard/pendingdocumenttourbooking"
          element={<PendingDocumentTourBooking />}
        />
        <Route path="dashboard/bookings" element={<TotalTourBooking />} />
        {/* <Route path="dashboard/payments" element={<TotalPayment />} /> */}
        <Route
          path="dashboard/pendingpayments"
          element={<TotalPendingPayment />}
        />
        <Route
          path="dashboard/next15daysdeparture"
          element={<TotalDepartureInNextFifteenDay />}
        />
        <Route path="*" element={<h1>404</h1>} />
      </Route>
    </Routes>
  );
};

export default MainRouter;
